import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LoadingSplash } from "@songtradr/design-language";
import { forwardAuth } from "../../shared/utils/api.utils";
import { useLoaderData } from "./OauthCallback.Parts";

export const OauthCallback = () => {
  const navigate = useNavigate();
  const { exchangeFederatedToken: redirectUrl } = useLoaderData();

  useEffect(() => {
    if (redirectUrl) navigate(redirectUrl, { replace: true });
    else forwardAuth();
  }, [redirectUrl, navigate]);

  return <LoadingSplash />;
};
